import { UserAbridged } from "./user-abridged.model";

export class ContractorAbridged {
  id: number;
  name: string;
  manager: UserAbridged;

  public deserialize(input: any): this {
    this.id = input.id;
    this.name = input.name;
    this.manager = input.maintenanceManager ? (new UserAbridged()).deserialize(input.maintenanceManager) : null;

    return this;
  }
};
